module.exports = __webpack_public_path__ + "static/media/icon_contact_black.03f1f06f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/Icons/icon_contact_black.svg
// module id = 803
// module chunks = 0